import { DBLTable } from '@ui/components/elements'
import { AttributeKey, DatableDataType, DatableLog } from '@ui/interfaces'

interface CollapsedProps {
  events: { input: DatableLog; output: DatableLog }[]
  isLoading: boolean
  dataSource: DatableDataType
  columnWidth: number
  primaryKeys: string[]
  uniqueKeys: AttributeKey[]
}

export const Collapsed = ({ events, isLoading, dataSource, columnWidth, primaryKeys, uniqueKeys }: CollapsedProps) => {
  return (
    <div className="h-[calc(100vh-11.25rem)]">
      <DBLTable
        tableData={events}
        loading={isLoading}
        dataSource={dataSource}
        tableType={'output'}
        defaultColumnOrder={[...primaryKeys]}
        uniqueKeys={uniqueKeys}
        hideHeaders={true}
        condensedStyle={true}
        customColumnWidth={columnWidth}
      />
    </div>
  )
}
